import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  IA_STI_INQUIRY_RESET_ITEM_DETAILS,
} from './constants';

export function resetItemDetails() {
  return {
    type: IA_STI_INQUIRY_RESET_ITEM_DETAILS,
  };
}

export function useResetItemDetails() {
  const dispatch = useDispatch();
  const boundAction = useCallback(() => dispatch(resetItemDetails()), [dispatch]);
  return { resetItemDetails: boundAction };
}

export function reducer(state, action) {
  switch (action.type) {
    case IA_STI_INQUIRY_RESET_ITEM_DETAILS:
      return {
        ...state,
        itemDetails: null,
        fetchItemDetailsError: null,
      };

    default:
      return state;
  }
}


